/* eslint-disable @typescript-eslint/no-unsafe-assignment,import/no-cycle */
import useCheckout from 'components/ui/organisms/monarch/rules/checkout/useCheckout';
import { MonarchTestHook } from '../types';
import useCheckoutExampleTest from './CheckoutExampleTest/useCheckoutExampleTest';

// Map of experiment rules
export const ruleMap: Record<string, MonarchTestHook> = {
    useDegreeDetailRedesignTraffic: useCheckoutExampleTest,
    checkout: useCheckout,
};
